import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from '../Services/translation';
import { setTosAndDataPrivacy, activeSignInSection, activeCustomerAddress, activeDeliverySection, showConfirmLogin, showBahagSignIn, showBahagSignUp, showBahagForgetPassword, login, logout, setSignUpForm, getCurrentCustomer, setCurrentCustomer } from '../actions/Bahag.action';
import { setCookie } from "../Components/AB-test-read-more";
class BahagLoggedin extends Component {
    constructor(props) {
        super(props);
        this.handleLogout = this.handleLogout.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
    }

    renderConfirmLogin() {
        const loggedInUser = this.props.customerInfo;
        let customerName = "";
        if (loggedInUser) {
            customerName = this.props.customerInfo.first_name + " " + this.props.customerInfo.last_name;
        }
        return (
            <>
                <h3 id="bahag-signin" className="checkout__section-title">{translate('checkout.bahag.signin.header')}</h3>
                <div className="germany-section__loggedin-container">
                    <div className="germany-section__loggedin">
                        <div className="germany-section__loggedin--icon-container">
                            <span></span>
                        </div>
                        <div className="germany-section__loggedin--text-container">
                            <p className="germany-section__loggedin--text-container--title">{translate("checkout.bahag.loggedin.confirmation.title")}</p>
                            <p className="germany-section__loggedin--text-container--description">{translate("checkout.bahag.loggedin.confirmation.description")} </p>
                            <div className="germany-section__loggedin--text-container--userName">{customerName}</div>
                        </div>
                        <button onClick={this.handleLogout} className="germany-section__loggedin--singout-button">{translate("checkout.bahag.signout.button")}</button>
                    </div>
                    <button onClick={this.handleContinue} className="germany-section__loggedin-container--button">{translate("checkout.bahag.loggedin.confirmation.continue")}</button>
                </div>
            </>
        )
    }

    async handleContinue() {
        await this.props.getCurrentCustomer(this.props.authorizationHybris);
        this.props.activeDeliverySection(true);
        this.scrollToDeliverySection();
    }

    scrollToDeliverySection() {
        const bahagDelivery = document.getElementById("bahag-delivery");
        if (bahagDelivery) {
            bahagDelivery.scrollIntoView({ behavior: 'smooth' });
        }
    }

    async handleLogout() {
        const logoutResponse = await this.props.logout(this.props.authorizationHybris);
        if (logoutResponse) {
            const logoutResponseStatus = logoutResponse.Data;
            if (logoutResponseStatus === 200) {
                setCookie("authorizationHybris", "", 20);
                this.props.activeDeliverySection(false);
                this.props.activeCustomerAddress(false);
                this.props.activeSignInSection(false);
                this.props.showBahagSignIn(true);
                this.props.setTosAndDataPrivacy(false);
                this.props.setCurrentCustomer({});

                const emptySignUpForm = {
                    deviceId: "CTEK",
                    firstname: "",
                    lastname: "",
                    address: "",
                    zipCode: "",
                    city: "",
                    phone: "",
                    email: "",
                    password: "",
                    confirmPassword: "",
                    houseNumber: ""
                }
                
                this.props.setSignUpForm(emptySignUpForm);
            }
        }

    }

    render() {
        return (
            <div >
                {this.renderConfirmLogin()}
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => ({
    showConfirmLogin: () => dispatch(showConfirmLogin(true)),
    showBahagSignIn: () => dispatch(showBahagSignIn(true)),
    showBahagSignUp: () => dispatch(showBahagSignUp(true)),
    showBahagForgetPassword: () => dispatch(showBahagForgetPassword(true)),
    login: (email) => dispatch(login(email)),
    logout: (authorizationHybris) => dispatch(logout(authorizationHybris)),
    activeDeliverySection: (isActiveDeliverySection) => dispatch(activeDeliverySection(isActiveDeliverySection)),
    activeCustomerAddress: (isActiveCustomerAddress) => dispatch(activeCustomerAddress(isActiveCustomerAddress)),
    activeSignInSection: (isSignInSectionActive) => dispatch(activeSignInSection(isSignInSectionActive)),
    setTosAndDataPrivacy: (checked) => dispatch(setTosAndDataPrivacy(checked)),
    setSignUpForm: (form) => dispatch(setSignUpForm(form)),
    getCurrentCustomer: (authorizationHybris) => dispatch(getCurrentCustomer(authorizationHybris)),
    setCurrentCustomer: () => dispatch(setCurrentCustomer()),
});

const mapStateToProps = state => {
    return {
        customerInfo: state.bahag.customerInfo,
        authorizationHybris: state.bahag.authorizationHybris
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(BahagLoggedin);
